import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import axios from "axios";

function OrderList() {  
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [orderList, setOrderList] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const filterDetails = (item) => {
    navigate('./single', { state: { item } });
  };

  const orderListFetch = async () => {
    try {
      setLoader(true);
      const token = Cookies.get('s_l');  
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/orders/list`);
      console.log(response, 'orders list');
      if (response.data && response.data.data && Array.isArray(response.data.data.list)) {
        setOrderList(response.data.data.list);
      } else {
        setOrderList([]);
      }
      setLoader(false);
    } catch (error) {
      console.error(error);
      setOrderList([]);
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    orderListFetch();
  }, []);

  // Filtered orders by search
  const filteredOrders = useMemo(() => {
    if (!Array.isArray(orderList)) return [];
    if (!searchText.trim()) return orderList;
    const q = searchText.trim().toLowerCase();
    return orderList.filter((order) => {
      const userName = (order.user_name || "").toLowerCase();
      const orderUuid = (order.order_uuid || "").toLowerCase();
      const id = String(order.id || "").toLowerCase();
      return userName.includes(q) || orderUuid.includes(q) || id.includes(q);
    });
  }, [orderList, searchText]);

  // Pagination logic
  const totalItems = filteredOrders.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  // Keep currentPage within valid range whenever totalPages or itemsPerPage changes
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedOrders = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredOrders.slice(startIndex, endIndex);
  }, [filteredOrders, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  return (
    <div className="main-content">
      {loader ? 
        <Loader />
        :
        <>
          {/* New User Registration */}
          <div className="section">
            <div className="row">
              {/* Past Order */}
              <div className="col-md-12">
                <div className="card mb-3 p-2">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h5>All Order Items</h5>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Order UUID, User Name, ID..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th style={{ maxWidth: 350 }}>User Name</th>
                          <th>Order UUID</th>
                          <th className="text-center">Date of Order</th>
                          <th className="text-center">Order Status</th>
                          <th className="text-center">Order Amount</th>
                          <th className="text-center">Total Items</th>
                          <th className="text-center">Payment Type</th>
                          <th className="text-center">Payment Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedOrders && paginatedOrders.length > 0 ? (
                          paginatedOrders.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.id}</td>
                                <td>{item.user_name}</td>
                                <td>{item.order_uuid}</td>
                                <td className="text-center">{item.order_date}</td>
                                <td className="text-center">
                                  {item.order_status == 1 ? <Badge bg="primary"> New</Badge> : 
                                    (item.order_status == 2) ? <Badge bg="success"> Accepted </Badge> : 
                                      (item.order_status == 6) ? <Badge bg="danger"> Canceled </Badge> : 
                                        (item.order_status == 3) ? <Badge bg="warning"> Dispatch </Badge> : 
                                          (item.order_status == 5) ? <Badge bg="warning"> Delivered </Badge> : 
                                            (item.order_status == 4) ? <Badge bg="secondary"> Out For Delivered</Badge> : 
                                              <Badge bg="success"> Cancelled By admin</Badge>}
                                </td>
                                <td className="text-center">
                                  <div className="fw-bold text-success" style={{ fontSize: '14px' }}>
                                    ₹ {Number(item.overall_price ?? item.order_amount ?? 0).toFixed(2)}
                                  </div>
                                </td>
                                <td className="text-center"> {item.total_items}</td>
                                <td className="text-center ">
                                  {item.payment_type == 'COD' ? <Badge className="text-dark" bg="warning"> Cash On delivery</Badge> : <Badge className="text-light" bg="primary"> Online Payment</Badge>}
                                </td>
                                <td className="text-center ">
                                  {item.payment_status == 1 ? <Badge className="text-light" bg="success"> Pending</Badge> : (item.payment_status == 2) ? <Badge className="text-light" bg="primary"> Paid</Badge> 
                                    : <Badge className="text-light" bg="danger"> Failed</Badge>
                                  }
                                </td>
                                <td className="text-center">
                                  <button onClick={() => filterDetails(item.id)} className="btn btn-xs btn-primary text-white">View Order Detail</button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr><td colSpan={10} className="text-center">No data found</td></tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div className="flex items-center justify-between mt-4 px-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1rem', padding: '0 0.5rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>Show</span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{ padding: '0.25rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', outline: 'none', background: '#fff' }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>entries</span>
                        </div>

                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span className="text-sm font-medium px-2 text-gray-700" style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}>
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}

export default OrderList;
